import {
  UPDATE_LIVESTREAMS,
  EVENT_HAS_TIIVII_OTT_CONFIG,
  EVENT_HAS_TIIVII_RTMP_CONFIG,
  EVENT_SHOW_DELETED,
  STORE_DEPLOYMENT_SOURCES,
  STORE_EVENT_TO_COPY,
} from "./action-types";

export const updateLivestreamsActionCreator = data => ({
  type: UPDATE_LIVESTREAMS,
  data,
});

export const storeTiiviiOttConfigActionCreator = data => ({
  type: EVENT_HAS_TIIVII_OTT_CONFIG,
  data,
});

export const storeDeploymentSourcesActionCreator = data => ({
  type: STORE_DEPLOYMENT_SOURCES,
  data,
});

export const storeTiiviiRtmpConfigActionCreator = data => ({
  type: EVENT_HAS_TIIVII_RTMP_CONFIG,
  data,
});

export const storeShowDeletedEventsActionCreator = data => ({
  type: EVENT_SHOW_DELETED,
  data,
});

export const storeEventToCopyActionCreator = data => ({
  type: STORE_EVENT_TO_COPY,
  data,
});
